module.exports = __webpack_public_path__ + "static/Picture1-30c475a0e512ebb0e881e50ee4ff8a4f.jpg";